
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2232_4195)"}},[_c('circle',{attrs:{"cx":"32","cy":"32.715","r":"32","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M15.98 33.14c.319 0 .638-.091.912-.32l9.311-8.078 5.934 5.157c.547.457 1.323.457 1.825-.045l9.22-8.444 2.328 2.328c.274.274.594.411.959.411.137 0 .274 0 .41-.045.503-.137.868-.548.96-1.05l1.505-7.714a1.353 1.353 0 00-.365-1.232 1.353 1.353 0 00-1.232-.365l-7.76 1.46a1.33 1.33 0 00-1.05.959c-.137.502 0 1.004.32 1.37l1.962 1.962-8.215 7.53-5.934-5.157a1.328 1.328 0 00-1.78 0l-10.224 8.855a1.329 1.329 0 00-.137 1.917c.274.32.684.502 1.05.502zM46.285 16.8l-.639 3.195-2.601-2.602 3.24-.593z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M52.631 49.754h-2.83V33.185c0-.776-.593-1.37-1.37-1.37-.775 0-1.369.594-1.369 1.37v16.569h-2.738v-21.59c0-.776-.593-1.37-1.37-1.37-.776 0-1.369.594-1.369 1.37v21.59h-2.739V37.749c0-.776-.593-1.37-1.369-1.37s-1.37.594-1.37 1.37v12.005H33.37V41.4c0-.776-.593-1.37-1.369-1.37s-1.37.594-1.37 1.37v8.353h-2.738V33.185c0-.776-.593-1.37-1.37-1.37-.775 0-1.369.594-1.369 1.37v16.569h-2.738v-4.701c0-.776-.593-1.37-1.37-1.37-.775 0-1.369.593-1.369 1.37v4.7h-2.738v-8.809c0-.776-.593-1.37-1.37-1.37-.775 0-1.369.594-1.369 1.37v8.81h-2.83c-.775 0-1.369.593-1.369 1.369s.593 1.37 1.37 1.37h41.26c.776 0 1.37-.594 1.37-1.37 0-.776-.593-1.37-1.37-1.37h.001z","fill":"#74DBB5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2232_4195"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .715)","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    